import './search_filters.scss';
/* global rp$, document, window */

const {
	prepareFilters,
} = require('public/js/components/search-filters');

var THE_SCRIPT = function () {
	const $onReady = require('public/js/lib/on-ready');
	const vp = require('public/js/components/vehicle');

	/********************************************
	 * Load Javascript for the Banner Vpicker Module
	 * -----------------------------------------
	 * @section product_recommended_js
	 ********************************************/
	(function SearchFiltersModule() {

		$onReady({
			rp$,
			window,
			label: 'search_filters',
			fn: function () {
				loadFilters();
			},
		});

		function loadFilters() {
			prepareFilters();
		}
	})();
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	if (typeof __CURRENT_SCRIPT__ === 'undefined') {
		throw new Error('__CURRENT_SCRIPT__ is not defined');
	}
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
